
import { singularityStore } from "@/store/store";
import { aiJobController } from "@/futurelayer/ai-job-manager/ai-jobs";
import PanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    PanelHeader
  }
})
export default class AIJobManager extends Vue {
  get aiJobs() {
    return singularityStore.aiJobs;
  }

  get sortedJobs() {
    const priorityOrder = { critical: 0, high: 1, normal: 2, low: 3 };
    return [...this.aiJobs].sort((a, b) =>
      priorityOrder[a.context.priority] - priorityOrder[b.context.priority]
    );
  }

  abortJob(id: number) {
    aiJobController.abortJob(id);
  }

  clearAllJobs() {
    aiJobController.clearAllJobs();
  }
}
